class Config {
  constructor() {
    // this.locale = "de";
    //startingData
    this.staringData = null;
    //callback function when data is ready : call from anywhere
    this.dataReady = () => {};
    //reseize UI
    this.ActiveReseize = false;
    //sound
    this.soundOn = true;
    this.soundAccess = true;
    this.youtubeAudioEnabled = true;
    this.MutedByFocus = false;
    this.AllAudios = [];
    this.AllHowlerAudios = {};
    this._audioUnlocked = false;
    //update goals count
    this.UpdateCount = false;
    this.UpdateCountData = {
      n: 0,
      data: []
    };
    this.backgroundLevels = [{
      L: 1,
      bg: "bg1",
      title: "FARMLAND"
    }, {
      L: 5,
      bg: "bg2",
      title: "SEALAND"
    }, {
      L: 10,
      bg: "bg3",
      title: "ICELAND"
    }, {
      L: 15,
      bg: "bg4",
      title: "DESERTLAND"
    }, {
      L: 20,
      bg: "bg5",
      title: "FORESTLAND"
    }];
    this.debug = false;
    this.production = false;
    this.assets = "assets";
    this.fps = 60;
    this.app = null;
    this.stage = null;
    this.startMoves = 20; //20
    this.playersNumber = 5; //initial players in the progress bar
    this.numProfiles = 80; //number of chanlengers
    this.profilesScoreBarStep = 30000; //interval d'appatition sur la barre
    this.scoreRangeMin = 500;
    this.scoreRangeMax = 999;
    this.lineSize = 10;
    this.lineDistance = 156;
    this.borderThickness = 20;
    this.particuleScale = 0.8;
    this.hintDelay = 5; // sec
    this.interstitialDelay = 90000; //ms
    this.interstitialDelay2 = 120000; //ms
    this.interstitialReady = false;
    this.bonus0 = 1;
    this.bonus1 = 1; // +100k  "bestScoreStep"
    this.bonus2 = 1; // beat somme one
    this.bonus3 = 30; // share featurs
    this.bonus4 = 10; // retry
    this.bonus5 = 3; // beat a real opponent
    this.bonus6 = 2; // achive classic objectif
    this.bonus7 = 3; // achive social objectif
    this.bonusBomb = 8;
    this.bonusConnexion = 9;
    this.bonusScore = 6;
    this.rocketsTriggerLimite = 9;
    this.bestScoreStep = 100000; // bonnus step
    this.oldScore = 0;
    this.oldCoins = 0;
    this.currentScore = 0;
    this.scoreMultiplier = 1;
    this.start = false;
    this.scoreCoef = 250; //score incrementation
    this.scoreHeaderCoef = 12; // score value scale
    this.levelProgressionMode = true;
    this.Selected_Bubbles = {
      x: 0,
      y: 0
    };

    //default pack
    this.colors = {
      green: "#4dba30",
      blue: "#5282f6",
      red: "#ff001d",
      violet: "#962beb",
      orange: "#f98c29"
    };

    //color pack0
    this.colors0 = {
      green: "#c79083",
      blue: "#dc2f69",
      red: "#823b28",
      violet: "#f7db47",
      orange: "#eb6b2b"
    };
    this.ementionTextColor = ["#ffffff", "#91ffff"];
    this.lineColor = "#4f4f4f";
    this.failTextColor = "#ffa6a4";
    this.ctaTextColor = "#ffffff";
    this.ctaColor = "#00e571";
    this.tryTextColor = "#ffffff";
    this.tryColor = "#f2187d";
    this.cadreP1Color = "#FFCA44";
    this.cadreP2Color = "#62ddfc";
    this.backAlpha = 0.25;
    this.lineAlpha = 0.5;
    this.explosionBlur = false;
    this.explosionBlurAlpha = 0.4;
    this.mouse = {
      x: 0,
      y: 0
    };
    this.view = {
      x: 608,
      y: 1080
    };
    this.haptic = true;
    this.linkSoundId = 0;
    this.burstSoundId = 0;
    this.hardLevelStep = 0;
    this.hardLevelStart = 10;
    this.replay = false;
    //Boosters
    this.bombDelay = 1.5; // delay after explod (sec)
    this.hammerDelay = 1; // delay after explod (sec)
    this.coins = 0;
    this.bonusCoins0 = 1; // apres une connexion >= 9 (bonusConnexion)
    this.bonusCoins1 = 10; // apres une RV ok
    this.bonusCoins2 = 50; // apres avoir challenger un ami
    this.bonusCoins3 = 2; // apres avoir finit un objectif
    this.rewardBonnus = [
    // rewardedInterstitialAd bonnus with priority (coef)
    {
      id: "bomb",
      coef: 0.14
    }, {
      id: "rocket",
      coef: 0.14
    }, {
      id: "swap",
      coef: 0.14
    }, {
      id: "hammer",
      coef: 0.14
    }, {
      id: "2moves",
      coef: 0.14
    }, {
      id: "4moves",
      coef: 0.14
    }, {
      id: "25coins",
      coef: 0.14
    }, {
      id: "50coins",
      coef: 0.14
    }];
    this.dailyBonnus = [
    //
    {
      id: "bomb",
      coef: 0.14
    }, {
      id: "rocket",
      coef: 0.14
    }, {
      id: "swap",
      coef: 0.14
    }, {
      id: "hammer",
      coef: 0.14
    }, {
      id: "coins",
      coef: 0.14
    }];
    this.bombCoinsVal = 25; //coins cost
    this.rocketCoinsVal = 25; //coins cost
    this.swapCoinsVal = 25; //coins cost
    this.hammerCoinsVal = 25; //coins cost

    this.boosterRvConsumed = false;
    this.leaderBoardStep = 200; //50000;
    this.selectedSkin = 0;
    this.purchasedTheme = [0];
    this.beatenOpponent = "";

    this.playerLevel = 1;
    this.MaxLevel = 1;
    this.goalAchieved = false;
    this.gpuTierInfo = {
      tier: 1
    };
  }
}
export default new Config();
